var render, staticRenderFns
import script from "./baseOfertas.vue?vue&type=script&lang=js"
export * from "./baseOfertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad4db62e')) {
      api.createRecord('ad4db62e', component.options)
    } else {
      api.reload('ad4db62e', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/Ofertas/baseOfertas.vue"
export default component.exports